import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressCrmAutomationsAutomationsCustomTriggerAutomationsCustomTriggerServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'bo._base_domain_': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    'platform.rise.ai': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
      {
        srcPath: '/_api/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/crm-automations-utils',
        destPath: '',
      },
    ],
    'payments.base44.com': [
      {
        srcPath: '/_serverless/crm-automations-utils',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_automations_custom-trigger';

/** Runs the automation associated with the trigger ID that you pass to it. */
export function runTrigger(payload: object): RequestOptionsFactory<any> {
  function __runTrigger({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.automations.v1.automations_custom_trigger',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.crm.automations.automations_custom_trigger.AutomationsCustomTriggerService.RunTrigger',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCrmAutomationsAutomationsCustomTriggerAutomationsCustomTriggerServiceUrl(
        { protoPath: '/v1/trigger-custom', data: payload, host }
      ),
      data: payload,
    };

    return metadata;
  }

  return __runTrigger;
}

export function bulkUpdateMainEntityTags(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUpdateMainEntityTags({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.automations.v1.automations_custom_trigger',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.crm.automations.automations_custom_trigger.AutomationsCustomTriggerService.BulkUpdateMainEntityTags',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCrmAutomationsAutomationsCustomTriggerAutomationsCustomTriggerServiceUrl(
        { protoPath: '/v1/bulk-update-main-entity-tags', data: payload, host }
      ),
      data: payload,
    };

    return metadata;
  }

  return __bulkUpdateMainEntityTags;
}

export function bulkUpdateMainEntityTagsByFilter(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUpdateMainEntityTagsByFilter({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.automations.v1.automations_custom_trigger',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.crm.automations.automations_custom_trigger.AutomationsCustomTriggerService.BulkUpdateMainEntityTagsByFilter',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressCrmAutomationsAutomationsCustomTriggerAutomationsCustomTriggerServiceUrl(
        {
          protoPath: '/v1/bulk-update-main-entity-tags-by-filter',
          data: payload,
          host,
        }
      ),
      data: payload,
    };

    return metadata;
  }

  return __bulkUpdateMainEntityTagsByFilter;
}
